import heroMapping from "../components/heroMapping";
import recipesComponentMapping from "../components/recipesComponentMapping";

const recipesPageMapping = (data) => {
  const mappedData = {};
  let components = data.data.relationships.field_components.data;
  mappedData.hero = heroMapping(components.find(component => {
    return component.type === "paragraph--hero_carousel_component"
  }));
  mappedData.recipesComponent = recipesComponentMapping(components.find(component => {
    return component.type === "paragraph--recipes_component"
  }));

  return mappedData;
};

export default recipesPageMapping;
